/**
 * What an app reads and does, in a person's words (D354 phase 3): each Control API method an app may name, as the thing a
 * person knows it by. DOM-free and zod-free, shared by the host (which fills an app's `reads` and `writes`), the proposal card
 * and the tests.
 */
/** Each readable method as the thing a person knows it by. */
export const READ_METHOD_WORDS = {
    "workbench.status": "how busy the workbench is",
    "sessions.list": "your agents' sessions",
    "agents.activity": "what your agents are doing",
    "teams.list": "your teams",
    "runs.list": "your agents' runs",
    "usage.history": "your usage and spend",
    "commits.timeline": "recent commits",
    "pullRequests.list": "pull requests",
    "pipelines.list": "pipelines and their runs",
    "board.list": "your tasks",
    "plans.list": "your plans",
    "plans.get": "a plan's steps",
    "roadmap.get": "the roadmap",
    "decisions.list": "decisions",
    "memory.status": "the project's memory",
};
/** Each writable method as what it lets the app do. */
export const WRITE_METHOD_WORDS = {
    "board.create": "add a task",
    "board.update": "change a task",
    "board.move": "move a task",
    "board.assign": "assign a task",
    "board.comment": "comment on a task",
    "roadmap.upsert": "change the roadmap",
    "facilitator.send": "send a message to an agent",
};
const hostOf = (url) => {
    try {
        return new URL(url).host || url;
    }
    catch {
        return url;
    }
};
/**
 * The distinct things an app's reads cover, in words: Control API reads as the thing a person knows them by, a tool read as
 * "the list_incidents tool on PagerDuty", a web read as "web data from api.example.com". What the "Reads ..." line says.
 */
export function readWords(bindings, extra = {}) {
    const own = bindings.map((b) => READ_METHOD_WORDS[b.method] ?? b.method);
    const tools = (extra.toolReads ?? []).map((t) => `the ${t.tool} tool on ${t.server}`);
    const web = (extra.webReads ?? []).map((w) => `web data from ${hostOf(w.url)}`);
    return [...new Set([...own, ...tools, ...web])];
}
/** The distinct things an app's actions may do, in words. */
export function writeWords(actions) {
    return [...new Set(actions.map((a) => WRITE_METHOD_WORDS[a.method] ?? a.method))];
}
//# sourceMappingURL=appWords.js.map